import React from 'react';

import QuotaArcorProducts  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/QuotaProducts/List.js';

export default function () {
  return <QuotaArcorProducts  />;
}